module.exports = __webpack_public_path__ + "static/media/temp_22.c7803dfa.jpg";